module.exports = __webpack_public_path__ + "static/media/rasmus.c83d7221.JPG";